module.exports = __webpack_public_path__ + "img/1005.a52479f8.jpg";